export const initTimersContainer = () => {
    const QTContainer = document.createElement("div");
    QTContainer.id = "QTContainer";
    QTContainer.classList.add("qt_infoContainer");
    l("sectionLeft")?.appendChild(QTContainer);
};
